import React from 'react';
import { applyImageBgColor } from '../../layouts/ImageTabs/logic';
import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';

export interface ViewerContentProps extends DefaultBsComponent {
  background?: string;
}

export const ViewerContent = ({
  className,
  background,
  children,
}: ViewerContentProps) => {
  return (
    <div
      className={classNames(
        'ViewerContent',
        'flex justify-center items-center rounded-18',
        className,
        'relative transition-all duration-500 overflow-hidden',
        background && applyImageBgColor(background)
      )}
    >
      {children}
    </div>
  );
};
